<template>
  <AiEducationLayout :menu-items="menuItems">
    <EducationPageHeader title="学习首页" description="查看课程进度、待完成任务和学习建议" />
    <el-row :gutter="16">
      <el-col :xs="24" :sm="12" :lg="8"
        ><ContentWrap
          ><div class="student-card"
            ><span>我的课程</span><strong>{{ scopeCourseCount }}</strong
            ><small>当前授权范围</small></div
          ></ContentWrap
        ></el-col
      >
      <el-col :xs="24" :sm="12" :lg="8"
        ><ContentWrap
          ><div class="student-card"
            ><span>学习状态</span><strong>准备开始</strong
            ><small>完成课程后显示真实进度</small></div
          ></ContentWrap
        ></el-col
      >
      <el-col :xs="24" :sm="12" :lg="8"
        ><ContentWrap
          ><div class="student-card"
            ><span>AI 学伴</span><strong>可用</strong><small>回答将遵循知识库和适龄规则</small></div
          ></ContentWrap
        ></el-col
      >
    </el-row>
    <ContentWrap>
      <EducationState
        state="empty"
        title="暂无学习任务"
        description="当学校或教师发布课程、作业后，会在这里显示。"
        action-text="查看我的课程"
        @action="router.push('/ai-Application-center/ai-education/student/courses')"
      />
    </ContentWrap>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import AiEducationLayout from '../layout/AiEducationLayout.vue'
import type { EducationMenuItem } from '../layout/types'
import EducationPageHeader from '../components/EducationPageHeader.vue'
import EducationState from '../components/EducationState.vue'
import { useEducationWorkspace } from '../composables/useEducationWorkspace'

defineOptions({ name: 'AiEducationStudentHome' })
const router = useRouter()
const { workspace, initialize } = useEducationWorkspace()
const menuItems: EducationMenuItem[] = [
  {
    title: '学习首页',
    path: '/ai-Application-center/ai-education/student/home',
    icon: 'ep:home-filled'
  },
  {
    title: '我的课程',
    path: '/ai-Application-center/ai-education/student/courses',
    icon: 'ep:reading'
  },
  {
    title: '我的作业',
    path: '/ai-Application-center/ai-education/student/assignments',
    icon: 'ep:document-checked'
  },
  {
    title: '学习计划',
    path: '/ai-Application-center/ai-education/student/learning-plans',
    icon: 'ep:calendar'
  },
  {
    title: '学习报告',
    path: '/ai-Application-center/ai-education/student/learning-report',
    icon: 'ep:data-analysis'
  },
  {
    title: '错题本',
    path: '/ai-Application-center/ai-education/student/wrong-answers',
    icon: 'ep:warning'
  },
  {
    title: 'AI 学伴',
    path: '/ai-Application-center/ai-education/student/assistant',
    icon: 'ep:magic-stick'
  }
]
const scopeCourseCount = computed(() => workspace.value?.dataScope.teachingClassIds.length || 0)
onMounted(() => initialize())
</script>

<style scoped>
.student-card {
  display: flex;
  min-height: 110px;
  flex-direction: column;
  gap: 8px;
}
.student-card span,
.student-card small {
  color: #697681;
}
.student-card strong {
  color: #19705d;
  font-size: 26px;
}
</style>
